import { useEffect, useState } from "react";
import MaskAndValid from "utils/maskAndValid";

import Snackbar from "components/Alerts/Snackbar";
import HeaderClientes from "components/_refactor/headers/clients";
import componentStylesButtons from "assets/theme/components/button.js";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import moment from "moment";

import UploadFileMultiple from "components/Dropzone/UploadFileMultiple";

import Api from "lib/api/httpRequestHelper.js";
import useAlert from "components/Alerts/useAlert";
import UtilsFncs from "utils/UtilsFncs";

import { makeStyles, withStyles } from "@material-ui/core/styles";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";

import DateField from "components/_refactor/fields/date";
import InputText from "components/_refactor/text/input";
import CurrencyField from "components/_refactor/fields/number";
import { getUserName } from "utils/get-user-info";

const SelectOption = withStyles(() => ({
  label: {
    fontSize: "1rem",
  },
  root: {
    marginBottom: 0,
  },
}))(FormControlLabel);

const useStylesButtons = makeStyles(componentStylesButtons);

const optionsGravidade = [
  {
    name: "Extrema",
    value: "Extrema",
  },
  {
    name: "Alta",
    value: "Alta",
  },
  {
    name: "Média",
    value: "Média",
  },
  {
    name: "Baixa",
    value: "Baixa",
  },
  {
    name: "Nenhuma",
    value: "Nenhuma",
  },
];

const optionsUrgencia = [
  {
    name: "Imediatamente",
    value: "Imediatamente",
  },
  {
    name: "Muito urgente",
    value: "Muito urgente",
  },
  {
    name: "Urgente",
    value: "Urgente",
  },
  {
    name: "Pouco urgente",
    value: "Pouco urgente",
  },
  {
    name: "Pode esperar",
    value: "Pode esperar",
  },
];

const optionsTendencia = [
  {
    name: "Irá piorar rapidamente",
    value: "Irá piorar rapidamente",
  },
  {
    name: "Irá piorar a curto prazo",
    value: "Irá piorar a curto prazo",
  },
  {
    name: "Irá piorar a médio prazo",
    value: "Irá piorar a médio prazo",
  },
  {
    name: "Irá piorar a longo prazo",
    value: "Irá piorar a longo prazo",
  },
  {
    name: "Não irá mudar",
    value: "Não irá mudar",
  },
];

const optionsPilar = [
  {
    name: "Pilar estratégico: CULTURA & GESTÃO - Evolução da Cultura Karsten S.A.",
    value:
      "Pilar estratégico: CULTURA & GESTÃO - Evolução da Cultura Karsten S.A.",
  },
  {
    name: "Pilar estratégico: CULTURA & GESTÃO - Sucesso de lideres, atração e desenvolvimento de talentos.",
    value:
      "Pilar estratégico: CULTURA & GESTÃO - Sucesso de lideres, atração e desenvolvimento de talentos.",
  },
  {
    name: "Pilar estratégico: BRANDING - Evolução de governança, competências e estratégias de Branding Karsten.",
    value:
      "Pilar estratégico: BRANDING - Evolução de governança, competências e estratégias de Branding Karsten.",
  },
  {
    name: "Pilar estratégico: BRANDING - Evolução de governança, competências e estratégias de Branding Trussardi.",
    value:
      "Pilar estratégico: BRANDING - Evolução de governança, competências e estratégias de Branding Trussardi.",
  },
  {
    name: "Pilar estratégico: BRANDING - Desenvolvimento do Branding Corporativo.",
    value:
      "Pilar estratégico: BRANDING - Desenvolvimento do Branding Corporativo.",
  },
  {
    name: "Pilar estratégico: LIDERANÇA NO CORE - Desenho da estratégia de go to market.",
    value:
      "Pilar estratégico: LIDERANÇA NO CORE - Desenho da estratégia de go to market.",
  },
  {
    name: "Pilar estratégico: LIDERANÇA NO CORE - Plano para expansão e crescimento de receita para os canais B2B.",
    value:
      "Pilar estratégico: LIDERANÇA NO CORE - Plano para expansão e crescimento de receita para os canais B2B.",
  },
  {
    name: "Pilar estratégico: LIDERANÇA NO CORE - Soluções Digitais B2B",
    value: "Pilar estratégico: LIDERANÇA NO CORE - Soluções Digitais B2B",
  },
  {
    name: "Pilar estratégico: CRESCIMENTO B2C - Franquias Trussardi",
    value: "Pilar estratégico: CRESCIMENTO B2C - Franquias Trussardi",
  },
  {
    name: "Pilar estratégico: CRESCIMENTO B2C - Plano para expansão e crescimento de receita para os canais B2C",
    value:
      "Pilar estratégico: CRESCIMENTO B2C - Plano para expansão e crescimento de receita para os canais B2C",
  },
  {
    name: "Pilar estratégico: CRESCIMENTO B2C - Produtos complementares para B2B/B2C - Karsten",
    value:
      "Pilar estratégico: CRESCIMENTO B2C - Produtos complementares para B2B/B2C - Karsten",
  },
  {
    name: "Habilitador: GLOBAL SOURCING - Flexibilidade estratégica.",
    value: "Habilitador: GLOBAL SOURCING - Flexibilidade estratégica.",
  },
  {
    name: "Habilitador: TECNOLOGIA E INOVAÇÃO - Modernização do Sistema Legado",
    value:
      "Habilitador: TECNOLOGIA E INOVAÇÃO - Modernização do Sistema Legado",
  },
  {
    name: "Habilitador: TECNOLOGIA E INOVAÇÃO - Revisão do processo de gestão da inovação.",
    value:
      "Habilitador: TECNOLOGIA E INOVAÇÃO - Revisão do processo de gestão da inovação.",
  },
  {
    name: "Habilitador: TECNOLOGIA E INOVAÇÃO - Buscar a excelência operacional na cadeia produtiva.",
    value:
      "Habilitador: TECNOLOGIA E INOVAÇÃO - Buscar a excelência operacional na cadeia produtiva.",
  },
  {
    name: "Habilitador: TECNOLOGIA E INOVAÇÃO - Garantir a disciplina financeira.",
    value:
      "Habilitador: TECNOLOGIA E INOVAÇÃO - Garantir a disciplina financeira.",
  },
  {
    name: "Habilitador: ESG - Organização das ações de sustentabilidade, transparência e ética nos negócios.",
    value:
      "Habilitador: ESG - Organização das ações de sustentabilidade, transparência e ética nos negócios.",
  },
  {
    name: "Habilitador: NOVOS NEGÓCIOS - Criação da área de Business Development.",
    value:
      "Habilitador: NOVOS NEGÓCIOS - Criação da área de Business Development.",
  },
];

const optionsBenefiicos = [
  {
    name: "Atendimento à uma exigência legal",
    value: "Atendimento à uma exigência legal. ",
  },
  {
    name: "Irá aumentar a receita da empresa",
    value: "Irá aumentar a receita da empresa. ",
  },
  {
    name: "Irá reduzir as despesas da empresa",
    value: "Irá reduzir as despesas da empresa. ",
  },
  {
    name: "Trará aumento de eficiência operacional",
    value: "Trará aumento de eficiência operacional. ",
  },
  {
    name: "Irá ajudar a mitigar riscos",
    value: "Irá ajudar a mitigar riscos. ",
  },
];

const areaSolicitanteOptions = [
  {
    name: "Adm de Pessoal",
    value: "Adm de Pessoal",
  },
  {
    name: "Adm KNE",
    value: "Adm KNE",
  },
  {
    name: "Administração de Vendas",
    value: "Administração de Vendas",
  },
  {
    name: "ADRK",
    value: "ADRK",
  },
  {
    name: "Almoxarifado",
    value: "Almoxarifado",
  },
  {
    name: "Ambiental",
    value: "Ambiental",
  },
  {
    name: "Beneficiamento",
    value: "Beneficiamento",
  },
  {
    name: "Business Development",
    value: "Business Development",
  },
  {
    name: "Centro de Memória",
    value: "Centro de Memória",
  },
  {
    name: "Comercial",
    value: "Comercial",
  },
  {
    name: "Compras",
    value: "Compras",
  },
  {
    name: "Confecção Cama",
    value: "Confecção Cama",
  },
  {
    name: "Confecção Felpudo",
    value: "Confecção Felpudo"
  },
  {
    name: "Conselho",
    value: "Conselho",
  },
  {
    name: "Controladoria",
    value: "Controladoria",
  },
  {
    name: "CRM",
    value: "CRM",
  },
  {
    name: "Diretoria - Administrativa",
    value: "Diretoria - Administrativa",
  },
  {
    name: "Diretoria - B2B",
    value: "Diretoria - B2B",
  },
  {
    name: "Diretoria - Operações",
    value: "Diretoria - Operações",
  },
  {
    name: "Diretoria Industrial",
    value: "Diretoria Industrial",
  },
  {
    name: "E-commerce",
    value: "E-commerce",
  },
  {
    name: "EPPQ",
    value: "EPPQ",
  },
  {
    name: "ESG",
    value: "ESG",
  },
  {
    name: "Expedição",
    value: "Expedição",
  },
  {
    name: "Exportação",
    value: "Exportação",
  },
  {
    name: "Facção",
    value: "Facção",
  },
  {
    name: "Faturamento",
    value: "Faturamento",
  },
  {
    name: "Fiação",
    value: "Fiação",
  },
  {
    name: "Financeiro",
    value: "Financeiro",
  },
  {
    name: "Fiscal",
    value: "Fiscal",
  },
  {
    name: "Franquias",
    value: "Franquias",
  },
  {
    name: "Gestão Confecção",
    value: "Gestão Confecção",
  },
  {
    name: "Gestão de Pessoas",
    value: "Gestão de Pessoas",
  },
  {
    name: "Gestão Têxtil",
    value: "Gestão Têxtil",
  },
  {
    name: "Inteligência de Mercado Karsten",
    value: "Inteligência de Mercado Karsten",
  },
  {
    name: "Jurídico",
    value: "Jurídico",
  },
  {
    name: "Logística",
    value: "Logística",
  },
  {
    name: "Key Account",
    value: "Key Account",
  },
  {
    name: "Manutenção",
    value: "Manutenção",
  },
  {
    name: "Marketing",
    value: "Marketing",
  },
  {
    name: "Midia ADS Online",
    value: "Midia ADS Online",
  },
  {
    name: "Multimarcas",
    value: "Multimarcas",
  },
  {
    name: "NIK",
    value: "NIK",
  },
  {
    name: "Outsourcing",
    value: "Outsourcing",
  },
  {
    name: "PCM",
    value: "PCM",
  },
  {
    name: "PCP",
    value: "PCP",
  },
  {
    name: "Planejamento de Demanda",
    value: "Planejamento de Demanda",
  },
  {
    name: "Planejamento Estratégico",
    value: "Planejamento Estratégico",
  },
  {
    name: "Planejamento Varejo",
    value: "Planejamento Varejo",
  },
  {
    name: "Presidência",
    value: "Presidência",
  },
  {
    name: "S&OP",
    value: "S&OP",
  },
  {
    name: "SESMT",
    value: "SESMT",
  },
  {
    name: "SPK",
    value: "SPK",
  },
  {
    name: "Tecelagem",
    value: "Tecelagem",
  },
  {
    name: "Tecnologia da Informação",
    value: "Tecnologia da Informação",
  },
  {
    name: "Televendas",
    value: "Televendas",
  },
  {
    name: "Trade Marketing",
    value: "Trade Marketing",
  },
  {
    name: "Treinamento & Desenvolvimento",
    value: "Treinamento & Desenvolvimento",
  },
  {
    name: "Varejo",
    value: "Varejo",
  }
];

export default function ImprovementForm() {
  const classes = useStylesButtons();

  const { showSuccessAlert, showErrorAlert } = useAlert();
  const [creating, setCreating] = useState(false);
  const [msgErro, setMsgErro] = useState("");
  const [openErro, setOpenErro] = useState(false);
  const [msgSucesso, setMsgSucesso] = useState("");
  const [openSucesso, setOpenSucesso] = useState(false);
  const [descricaoCategoriaBeneficio, setDescricaoCategoriaBeneficio] =
    useState("");
  const [outroBeneficio, setOutroBeneficio] = useState("");
  const [descricaoBeneficio, setDescricaoBeneficio] = useState("");
  const [montanteFinanceiro, setMontanteFinanceiro] = useState("");
  const [projetoEstrategico, setProjetoEstrategico] = useState("");
  const [categoriaBeneficio, setCategoriaBeneficio] = useState("");
  const [processoDesenhado, setProcessoDesenhado] = useState("");
  const [descricaoMensurarBeneficio, setDescricaoMensurarBeneficio] =
    useState("");
  const [descricaoNecessidade, setDescricaoNecessidade] = useState("");
  const [tituloNecessidade, setTituloNecessidade] = useState("");
  const [descricaoSituacaoAtual, setDescricaoSituacaoAtual] = useState("");
  const [orcamentoPrevisto, setOrcamentoPrevisto] = useState("");
  const [contaContabil, setContaContabil] = useState("");
  const [keyusersDisponiveis, setKeyusersDisponiveis] = useState("");
  const [listaKeyusers, setListaKeyusers] = useState("");
  const [limitePrazo, setLimitePrazo] = useState("");
  const [alternativaCasoNaoImplementar, setAlternativaCasoNaoImplementar] =
    useState("");
  const [gravidade, setGravidade] = useState("");
  const [urgencia, setUrgencia] = useState("");
  const [tendencia, setTendencia] = useState("");
  const [dataLimite, setDataLimite] = useState("");
  const [dataAtualizacao, setDataAtualizacao] = useState("");
  const today = moment().format("YYYY-MM-DD");
  const [filesToConvert, setFilesToConvert] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const userName = getUserName();
  const [areaSolicitante, setAreaSolicitante] = useState("");
  const [anotherSystem, setAnotherSystem] = useState("");

  const [systemOptions, setSystemOptions] = useState([]);
  const [system, setSystem] = useState("");

  useEffect(() => {
    const fetchSystemOptions = async () => {
      try {
        const response = await Api.get("get-system-devops", "azureDevops", "");

        setSystemOptions([
          ...response?.Result?.map((item) => ({
            name: item.Nome,
            value: item.Nome,
          })),
          {
            name: "Outros",
            value: "OUTROS",
          },
        ]);
      } catch (error) {
        showErrorAlert(
          setMsgErro("Falha ao carregar opções de sistema"),
          setOpenErro(true)
        );
      }
    };

    fetchSystemOptions();
  }, []);

  useEffect(() => {
    const uploadPromises = filesToConvert.map((file) => {
      return UtilsFncs.FileToB64(file).then((base64) => {
        let encodedBase64 = base64?.toString()?.replace(/^data:(.*,)?/, "");

        if (encodedBase64.length % 4 > 0) {
          encodedBase64 += "="?.repeat(4 - (encodedBase64.length % 4));
        }

        const base64File = { Name: file.name, Base64: encodedBase64 };
        return base64File;
      });
    });
    Promise.all(uploadPromises)
      .then((encodedFiles) => {
        setFilesToUpload(encodedFiles);
        console.log(filesToUpload);
      })
      .catch((error) => {
        console.error("Erro ao fazer conversão dos arquivos:", error);
      });
  }, [filesToConvert]);

  const handleCloseSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
  };

  const handleCloseErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErro(false);
  };

  const handleCheckBox = (e) => {
    if (e.target.name === "projetoEstrategico") {
      if (projetoEstrategico.includes(e.target.value)) {
        const valor = projetoEstrategico.replace(e.target.value, "");
        setProjetoEstrategico(valor);
      } else {
        const valor = projetoEstrategico.concat(e.target.value);
        setProjetoEstrategico(valor);
      }
    } else if (e.target.name === "categoriaBeneficio") {
      if (categoriaBeneficio.includes(e.target.value)) {
        const valor = categoriaBeneficio.replace(e.target.value, "");
        setCategoriaBeneficio(valor);
      } else {
        const valor = categoriaBeneficio.concat(e.target.value);
        setCategoriaBeneficio(valor);
      }
    } else if (e.target.name === "outroBeneficio") {
      if (outroBeneficio.includes(e.target.value)) {
        const valor = outroBeneficio.replace(e.target.value, "");
        setOutroBeneficio(valor);
        setDescricaoCategoriaBeneficio("");
      } else {
        setOutroBeneficio(e.target.value);
      }
    }
  };

  const submit = async () => {
    setCreating(true);

    await Api.post(
      "insert-form-into-table",
      "azureDevops",
      {
        NomeUsuario: userName,
        DescricaoBeneficio: descricaoBeneficio.replace(/"/g, "'"),
        MontanteFinanceiro: montanteFinanceiro,
        ProjetoEstrategico: projetoEstrategico,
        CategoriaBeneficio: (
          categoriaBeneficio + descricaoCategoriaBeneficio
        ).replace(/"/g, ""),
        ProcessoDesenhado: processoDesenhado,
        DescricaoMensurarBeneficio: descricaoMensurarBeneficio.replace(
          /"/g,
          ""
        ),
        DescricaoNecessidade: descricaoNecessidade.replace(/"/g, "'"),
        TituloNecessidade: tituloNecessidade.replace(/"/g, "'"),
        DescricaoSituacaoAtual: descricaoSituacaoAtual.replace(/"/g, "'"),
        OrcamentoPrevisto: orcamentoPrevisto,
        ContaContabil: contaContabil,
        KeyusersDisponiveis: keyusersDisponiveis,
        ListaKeyusers: listaKeyusers,
        LimitePrazo: limitePrazo,
        AlternativaCasoNaoImplementar: alternativaCasoNaoImplementar.replace(
          /"/g,
          "'"
        ),
        Gravidade: gravidade.value,
        Urgencia: urgencia.value,
        Tendencia: tendencia.value,
        DataLimite: dataLimite,
        DataAtualizacao: dataAtualizacao,
        ArquivosAnexo: filesToUpload,
        AreaSolicitante: areaSolicitante.value || areaSolicitante,
        Sistema: system.value === "OUTROS" ? anotherSystem : system.value,
      },
      true
    )
      .then(({ Success }) => {
        if (Success) {
          showSuccessAlert(
            setMsgSucesso("Solicitação enviada com sucesso!"),
            setOpenSucesso(true),
            setTimeout(() => window.location.reload(true), 2000)
          );
        }
      })
      .catch(() => {
        showErrorAlert(
          setMsgErro("Falha no envio do formulário"),
          setOpenErro(true)
        );
      })
      .finally(() => setTimeout(() => setCreating(false), 3000));
  };

  return (
    <>
      <HeaderClientes
        section="Governança TI"
        subsection="Formulário Melhoria"
      />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Solicitação de Melhoria ou Projeto"
                titleTypographyProps={{
                  variant: "h2",
                }}
              />

              <CardContent>
                <FormControl component="fieldset" required>
                  <Grid container spacing={2}>
                    <Typography variant="h2">
                      PLANEJAMENTO ESTRATÉGICO
                    </Typography>
                    <Typography variant="h3">
                      Informe a qual Pilar/Projeto Estratégico a nova demanda
                      está associada:
                    </Typography>

                    {optionsPilar.map((option, idx) => (
                      <Grid item xs={12} key={option.value || idx}>
                        <SelectOption
                          name="projetoEstrategico"
                          control={
                            <Checkbox
                              size="small"
                              color="primary"
                              onClick={(e) => handleCheckBox(e)}
                              value={option.value}
                            />
                          }
                          label={option.name}
                        />
                      </Grid>
                    ))}
                  </Grid>

                  <Divider style={{ margin: "20px 0px" }} />

                  <Typography variant="h2">NECESSIDADE</Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <InputText
                        label="Título da necessidade"
                        value={tituloNecessidade}
                        onChange={(e) => setTituloNecessidade(e.target.value)}
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <InputText
                        label="Descreva em detalhes a necessidade (novo projeto, nova
                          demanda):"
                        value={descricaoNecessidade}
                        onChange={(e) =>
                          setDescricaoNecessidade(e.target.value)
                        }
                        rows="3"
                        multiline
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <InputText
                        label="Descreva em detalhes a situação atual:"
                        value={descricaoSituacaoAtual}
                        onChange={(e) =>
                          setDescricaoSituacaoAtual(e.target.value)
                        }
                        rows="3"
                        multiline
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <InputText
                        label="Qual alternativa de negócio caso a demanda não seja
                          implementada?"
                        value={alternativaCasoNaoImplementar}
                        onChange={(e) =>
                          setAlternativaCasoNaoImplementar(e.target.value)
                        }
                        rows="3"
                        multiline
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormGroup>
                        <Typography variant="h3">Arquivos Anexo:</Typography>

                        <FormControl>
                          <UploadFileMultiple
                            multiple
                            accept={[
                              ".xml",
                              ".csv",
                              ".rtf",
                              ".png",
                              ".jpg",
                              ".pdf",
                              ".pptx",
                              ".ppt",
                              ".txt",
                              ".doc",
                              ".docx",
                              ".xls",
                              ".xlsx",
                            ]}
                            message={"Selecione ou arraste seus arquivos aqui!"}
                            onChangeFiles={setFilesToConvert}
                          />
                        </FormControl>
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                      <AutoCompleteField
                        label="Área Solicitante"
                        name="areaSolicitante"
                        placeholder="Selecione a área solicitante"
                        options={areaSolicitanteOptions}
                        optionLabelKey="name"
                        optionIdKey="value"
                        onChange={setAreaSolicitante}
                        value={areaSolicitante}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <AutoCompleteField
                        label="Sistema/local que deseja que a melhoria seja
                          implantada:"
                        name="sistema"
                        placeholder="Sistema"
                        loading={systemOptions?.length === 0}
                        options={systemOptions}
                        optionLabelKey="name"
                        optionIdKey="value"
                        onChange={setSystem}
                        value={system}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      {system === "OUTROS" && (
                        <InputText
                          value={anotherSystem}
                          onChange={(e) => setAnotherSystem(e.target.value)}
                          required
                        />
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <FormGroup>
                        <Typography variant="h3">
                          O processo foi desenhado e está atualizado?
                        </Typography>
                        <RadioGroup
                          arial-label="processo Desenhado"
                          name="processoDesenhado"
                          value={processoDesenhado}
                          onChange={(e) => {
                            setProcessoDesenhado(e.target.value);
                          }}
                          required
                        >
                          <SelectOption
                            value="sim"
                            control={<Radio size="small" color="primary" />}
                            label="Sim"
                          />
                          <SelectOption
                            value="nao"
                            control={<Radio size="small" color="primary" />}
                            label="Não"
                          />
                        </RadioGroup>
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                      {processoDesenhado.includes("sim") && (
                        <FormGroup>
                          <DateField
                            label="Data de Atualização"
                            value={dataAtualizacao}
                            onChange={setDataAtualizacao}
                            disabled={false}
                            required={false}
                          />
                        </FormGroup>
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <FormGroup>
                        <Typography variant="h3">
                          Tem limite de prazo para execução da demanda?
                        </Typography>
                        <RadioGroup
                          name="limitePrazo"
                          defaultValue="nao"
                          value={limitePrazo}
                          onChange={(e) => {
                            setLimitePrazo(e.target.value);
                          }}
                          required
                        >
                          <SelectOption
                            value="sim"
                            control={<Radio size="small" color="primary" />}
                            label="Sim"
                          />
                          <SelectOption
                            value="nao"
                            control={<Radio size="small" color="primary" />}
                            label="Não"
                          />
                        </RadioGroup>
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                      {limitePrazo.includes("sim") && (
                        <FormGroup>
                          <DateField
                            label="Data Limite"
                            value={dataLimite}
                            onChange={setDataLimite}
                            disabled={false}
                            required={false}
                            isValidDate={(current) =>
                              current.format("YYYY-MM-DD") > today
                            }
                          />
                        </FormGroup>
                      )}
                    </Grid>
                  </Grid>

                  <Divider style={{ margin: "20px 0px" }} />

                  <Typography variant="h2">BENEFÍCIO(S)</Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <FormGroup>
                        <Typography
                          variant="h3"
                          style={{ marginRight: "1.2rem" }}
                        >
                          Informe quais os benefícios que a Karsten receberá com
                          a implementação dessa nova demanda:
                        </Typography>

                        {optionsBenefiicos.map((option, idx) => (
                          <SelectOption
                            key={option.value || idx}
                            name="categoriaBeneficio"
                            control={
                              <Checkbox
                                size="small"
                                color="primary"
                                onClick={(e) => handleCheckBox(e)}
                                value={option.value}
                              />
                            }
                            label={option.name}
                          />
                        ))}

                        <SelectOption
                          name="outroBeneficio"
                          control={
                            <Checkbox
                              size="small"
                              color="primary"
                              onClick={(e) => handleCheckBox(e)}
                              value="Outros benefícios"
                            />
                          }
                          label={"Outros benefícios"}
                        />

                        {outroBeneficio.includes("Outros") && (
                          <InputText
                            value={descricaoCategoriaBeneficio}
                            onChange={(e) => {
                              setDescricaoCategoriaBeneficio(
                                "Outros: " + e.target.value
                              );
                            }}
                            required
                          />
                        )}
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                      <InputText
                        label="Descreva de forma mais detalhada os respectivos
                          benefícios:"
                        value={descricaoMensurarBeneficio}
                        onChange={(e) => {
                          setDescricaoMensurarBeneficio(e.target.value);
                        }}
                        required
                        multiline
                        rows={3}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormGroup>
                        <Typography variant="h3">
                          Montante do benefício:
                        </Typography>

                        <CurrencyField
                          required
                          label="Valor"
                          placeholder="Montante financeiro"
                          value={montanteFinanceiro}
                          onChange={(value) =>
                            setMontanteFinanceiro(value.floatValue)
                          }
                        />
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                      <InputText
                        label="Descreva a memória de cálculo dos benefícios:"
                        value={descricaoBeneficio}
                        onChange={(e) => {
                          setDescricaoBeneficio(e.target.value);
                        }}
                        required
                        multiline
                        rows={3}
                      />
                    </Grid>
                  </Grid>

                  <Divider style={{ margin: "20px 0px" }} />

                  <Typography variant="h2">RECURSOS</Typography>
                  <Typography variant="h4">
                    Descreva abaixo quais recursos estão disponíveis para essa
                    nova demanda/projeto:
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <FormGroup>
                        <Typography variant="h3">
                          Tem orçamento previsto.
                        </Typography>

                        <CurrencyField
                          required
                          label="Orçamento"
                          value={orcamentoPrevisto}
                          onChange={(value) => {
                            setOrcamentoPrevisto(value.floatValue);
                          }}
                        />
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                      <InputText
                        label="Qual conta contábil/PI:"
                        value={contaContabil}
                        onChange={(e) => {
                          setContaContabil(e.target.value);
                        }}
                        required
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <FormGroup>
                        <Typography variant="h3">
                          Tem recursos de pessoas/keysuers:
                        </Typography>

                        <RadioGroup
                          name="keyusersDisponiveis"
                          value={keyusersDisponiveis}
                          onChange={(e) => {
                            setKeyusersDisponiveis(e.target.value);
                          }}
                          required
                        >
                          <SelectOption
                            value="sim"
                            control={<Radio size="small" color="primary" />}
                            label="Sim"
                          />
                          <SelectOption
                            value="nao"
                            control={<Radio size="small" color="primary" />}
                            label="Não"
                          />
                        </RadioGroup>
                      </FormGroup>
                    </Grid>

                    {keyusersDisponiveis.includes("sim") && (
                      <Grid item xs={12}>
                        <InputText
                          label="Lista de keyusers:"
                          value={listaKeyusers}
                          onChange={(e) => {
                            setListaKeyusers(e.target.value);
                          }}
                          required
                          multiline
                          rows={3}
                        />
                      </Grid>
                    )}
                  </Grid>

                  <Divider style={{ margin: "20px 0px" }} />

                  <Typography variant="h2">Análise GUT:</Typography>
                  <FormGroup>
                    <AutoCompleteField
                      label="Gravidade"
                      name="gravidade"
                      options={optionsGravidade}
                      optionLabelKey="name"
                      optionIdKey="id"
                      onChange={setGravidade}
                      value={gravidade}
                    />
                  </FormGroup>
                  <FormGroup>
                    <AutoCompleteField
                      label="Urgência"
                      name="urgencia"
                      options={optionsUrgencia}
                      optionLabelKey="name"
                      optionIdKey="id"
                      onChange={setUrgencia}
                      value={urgencia}
                    />
                  </FormGroup>
                  <FormGroup>
                    <AutoCompleteField
                      label="Tendência"
                      name="tendencia"
                      options={optionsTendencia}
                      optionLabelKey="name"
                      optionIdKey="id"
                      onChange={setTendencia}
                      value={tendencia}
                    />
                  </FormGroup>

                  <Box
                    textAlign="center"
                    marginTop="1.5rem"
                    marginBottom="1.5rem"
                  >
                    <Button
                      name="buttonSubmit"
                      variant="contained"
                      classes={{ root: classes.buttonContainedInfo }}
                      disabled={
                        creating ||
                        MaskAndValid.isNullOrEmpty(descricaoBeneficio) ||
                        MaskAndValid.isNullOrEmpty(montanteFinanceiro) ||
                        MaskAndValid.isNullOrEmpty(projetoEstrategico) ||
                        (MaskAndValid.isNullOrEmpty(outroBeneficio) &&
                          MaskAndValid.isNullOrEmpty(categoriaBeneficio)) ||
                        (outroBeneficio === "Outros benefícios" &&
                          MaskAndValid.isNullOrEmpty(
                            descricaoCategoriaBeneficio
                          )) ||
                        MaskAndValid.isNullOrEmpty(processoDesenhado) ||
                        (processoDesenhado === "sim" &&
                          MaskAndValid.isNullOrEmpty(dataAtualizacao)) ||
                        MaskAndValid.isNullOrEmpty(
                          descricaoMensurarBeneficio
                        ) ||
                        MaskAndValid.isNullOrEmpty(descricaoNecessidade) ||
                        MaskAndValid.isNullOrEmpty(tituloNecessidade) ||
                        MaskAndValid.isNullOrEmpty(descricaoSituacaoAtual) ||
                        MaskAndValid.isNullOrEmpty(orcamentoPrevisto) ||
                        MaskAndValid.isNullOrEmpty(contaContabil) ||
                        MaskAndValid.isNullOrEmpty(keyusersDisponiveis) ||
                        (keyusersDisponiveis === "sim" &&
                          MaskAndValid.isNullOrEmpty(listaKeyusers)) ||
                        MaskAndValid.isNullOrEmpty(limitePrazo) ||
                        (limitePrazo === "sim" &&
                          MaskAndValid.isNullOrEmpty(dataLimite)) ||
                        MaskAndValid.isNullOrEmpty(
                          alternativaCasoNaoImplementar
                        ) ||
                        MaskAndValid.isNullOrEmpty(gravidade) ||
                        MaskAndValid.isNullOrEmpty(urgencia) ||
                        MaskAndValid.isNullOrEmpty(tendencia) ||
                        MaskAndValid.isNullOrEmpty(areaSolicitante) ||
                        MaskAndValid.isNullOrEmpty(system) ||
                        (system === "OUTROS" &&
                          MaskAndValid.isNullOrEmpty(anotherSystem))
                      }
                      onClick={submit}
                    >
                      {creating ? "Enviando..." : "Enviar solicitação"}
                    </Button>
                  </Box>
                </FormControl>
              </CardContent>

              <Snackbar
                text={msgSucesso}
                open={openSucesso}
                autoHideDuration={6000}
                onClose={handleCloseSucesso}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                severity="success"
              />
              <Snackbar
                text={msgErro}
                open={openErro}
                autoHideDuration={6000}
                onClose={handleCloseErro}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                severity="error"
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
